import React from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export default class ListTutorialComponent extends React.Component {

    checkedTutorial = (e) => {
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            this.props.checkedTutorialShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedTutorial( this.props.actionKey );
        }
    }

	render() {
		return (
			<tr>
				<td className="text-center tutorial-selected">
                    <input 
                    	type="checkbox" 
                    	checked={this.props.tutorial.checked}  
                    	onChange={ this.checkedTutorial } 
                    />
                </td>
				<td>{ this.props.tutorial.title }</td>
				<td>{ this.props.tutorial.description }</td>
				<td className="text-center">
					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chỉnh sửa hướng dẫn
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-warning btn-sm m-1"
							onClick={ () => this.props.showModal(this.props.actionKey, 'edit') }
						>
							<MdEdit />
					  	</Button>
				  	</OverlayTrigger>

					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Xóa hướng dẫn
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-danger btn-sm m-1"
							onClick={ () => this.props.confirmDelete(this.props.tutorial.id) }
						>
							<MdDelete />
					  	</Button>
				  	</OverlayTrigger>
				  	
				</td>
			</tr>
		)
	}
}